import { render } from "./loading.vue?vue&type=template&id=00006972"
const script = {}

import "./loading.vue?vue&type=style&index=0&id=00006972&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/loading.vue'],['render',render],['__file',"loading.vue"]])

export default __exports__